<button type="button" class="close-icon-button" i18n-aria-label="@@S_CLOSE" aria-label="Close" [attr.a7s-id]="a7sId()" (click)="onClick()">
  <mat-icon class="mat-icon-size-xs" svgIcon="ds-ic-close"></mat-icon>
</button>
